/**
 * ISO/IEC 17021-1 accreditation states, as the data dictionary lists them.
 *
 * A closed set of three, held here rather than fetched: unlike the country and
 * accreditation-body registries, these are not administrator-maintained lists — adding a
 * fourth state would be a schema change. The server validates the value regardless, so a
 * client that drifts is refused rather than believed.
 */
export const ACCREDITATION_STATUSES = ["Active", "Suspended", "Withdrawn"] as const;
